import React, { useContext, useEffect, useReducer } from 'react';
import {Routes, Route, useLocation, useNavigate} from 'react-router-dom';

//component
import Navbar from './components/Navbar';
import Home from './components/Pages/Home'
import Create from './components/Pages/Create';
import Category from './components/Pages/Category';
import Profile from './components/Pages/Profile';
import Login from './components/Pages/Login';
import Register from './components/Pages/Register';
import Logout from './components/Pages/Logout';
import ReadMore from './components/Pages/ReadMore';
import EditBlog from './components/Pages/EditBlog'
import ProfileData from './components/Pages/ProfileData';
import OthersProfile from './components/Pages/OthersProfile';
import Error from './components/Pages/Error';

import { UserContext } from './context/UserContext';
import { reducer, initialState} from './reducers/ReducerFn'
import Explore from './components/Explore';
import { ToastContainer } from 'react-toastify';

//toastify css..
import 'react-toastify/dist/ReactToastify.css';

const Routing = () => {

    const {dispatch} = useContext(UserContext);
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))
        if(user) {
            dispatch({type:"USER", payload:user})
        }
        else {
            if(location.pathname !== "/" && !user) {
                console.log("user not found");
                navigate("/login");
              }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
           <Routes>
              <Route exact path='/' element={<Explore/>}></Route>
              <Route exact path='/login' element={<Login value="true"/>}></Route>
              <Route exact path='/register' element={<Register />}></Route>
              <Route exact path='/logout' element={<Logout />}></Route>
              
              <Route exact path='/articles' element={<Home />}></Route>
              
              <Route path='/articles/new' element={<Create />}></Route>
              <Route path='articles/:id' element={<ReadMore />}></Route>
              <Route path='articles/edit/:id' element={<EditBlog />}></Route>
              
              <Route path='category' element={<Category />}></Route>
              <Route path='category/:articleType' element={<Category />}></Route>
              
              <Route path='/profile' element={<Profile />}></Route>
              <Route path='/profile/:id' element={<OthersProfile />}></Route>

              <Route path='profile/edit' element={<ProfileData />}></Route>
              <Route path='profile/edit/:id' element={<ProfileData />}></Route>

              <Route path='*' element={<Error />}></Route>
           </Routes>
        </>
    )
}

const App = () => {
    const [state, dispatch] = useReducer(reducer, initialState)


    return(
        <>
        <UserContext.Provider value={{state, dispatch}}>
           <Navbar />
           <ToastContainer />
           <Routing />
        </UserContext.Provider>
        </>
    )
}

export default App
